import React from 'react';

const PaymentCard = () => {
  return (
    <div className="payment-card-container" style={{ perspective: '1500px' }}>
      <div
        className="payment-card"
        style={{
          width: '380px',
          height: '240px',
          background: 'linear-gradient(135deg, #1B9E4B 0%, #159642 100%)',
          borderRadius: '20px',
          padding: '28px',
          position: 'relative',
          boxShadow: '0 30px 60px rgba(27, 158, 75, 0.4), 0 0 100px rgba(27, 158, 75, 0.2)',
          transform: 'rotateY(-8deg) rotateX(5deg)',
          transition: 'transform 0.4s ease',
          overflow: 'hidden',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'rotateY(0deg) rotateX(0deg) scale(1.05)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'rotateY(-8deg) rotateX(5deg)'}
      >
        {/* Top Section: Chip and Logo */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex gap-3 items-center">
            {/* EMV Chip */}
            <div
              style={{
                width: '50px',
                height: '40px',
                background: 'linear-gradient(135deg, #F5C242 0%, #E0A82E 100%)',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '40px',
                  height: '30px',
                  borderRadius: '4px',
                  border: '1.5px solid rgba(0,0,0,0.15)',
                }}
              >
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '2px',
                  padding: '4px',
                  height: '100%',
                }}>
                  {[...Array(8)].map((_, i) => (
                    <div key={i} style={{
                      background: 'rgba(0,0,0,0.1)',
                      borderRadius: '1px',
                    }} />
                  ))}
                </div>
              </div>
            </div>
            
            {/* Saudi Riyal Logo */}
            <img
              src="https://customer-assets.emergentagent.com/job_a49fc96e-c6d1-4538-8241-3e5dffe114fb/artifacts/1tnawu9j_riyal%20logo.jpeg"
              alt="SAR"
              style={{
                width: '32px',
                height: '32px',
                filter: 'brightness(0) invert(1)',
                opacity: 0.85,
                borderRadius: '50%',
              }}
            />
          </div>

          {/* NFC/Contactless Icon */}
          <div style={{ 
            background: 'rgba(255, 255, 255, 0.15)',
            borderRadius: '50%',
            padding: '8px',
            backdropFilter: 'blur(10px)',
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white" opacity="0.9">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-12.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
            </svg>
          </div>
        </div>

        {/* ROYA Logo - New Design */}
        <div className="mb-8 mt-6">
          <div style={{ 
            display: 'inline-block',
            background: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '12px',
            padding: '6px 12px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}>
            <img
              src="https://customer-assets.emergentagent.com/job_a49fc96e-c6d1-4538-8241-3e5dffe114fb/artifacts/6uiz1cw4_WhatsApp%20Image%201447-06-18%20at%2008.46.59.jpeg"
              alt="ROYA"
              style={{
                height: '24px',
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>

        {/* Card Number */}
        <div style={{ 
          color: 'rgba(255,255,255,0.9)', 
          fontSize: '20px', 
          fontWeight: '600', 
          letterSpacing: '3px', 
          marginBottom: '20px', 
          fontFamily: 'monospace',
          textShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}>
          •••• •••• •••• 5544
        </div>

        {/* Bottom Section: Card Holder & Logos */}
        <div className="flex items-end justify-between">
          <div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '9px', fontWeight: '500', letterSpacing: '1px', marginBottom: '4px' }}>
              CARD HOLDER
            </div>
            <div style={{ color: 'rgba(255,255,255,0.95)', fontSize: '14px', fontWeight: '600', letterSpacing: '1px' }}>
              ROYA MEMBER
            </div>
          </div>

          {/* Payment Network Logos */}
          <div className="flex items-center gap-3">
            <div style={{ 
              background: 'white', 
              padding: '4px 10px', 
              borderRadius: '6px',
              fontWeight: '700',
              fontSize: '14px',
              color: '#1B9E4B',
              letterSpacing: '0.5px',
            }}>
              mada
            </div>
            <div style={{ 
              background: 'white', 
              padding: '4px 10px', 
              borderRadius: '6px',
              fontWeight: '700',
              fontSize: '14px',
              color: '#1A1F71',
              fontStyle: 'italic',
              letterSpacing: '0.5px',
            }}>
              VISA
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div
          style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            background: 'radial-gradient(circle, rgba(245, 194, 66, 0.2) 0%, transparent 70%)',
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-30px',
            left: '-30px',
            width: '150px',
            height: '150px',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%)',
            pointerEvents: 'none',
          }}
        />

        {/* Glossy Overlay */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '50%',
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, transparent 100%)',
            pointerEvents: 'none',
            borderRadius: '20px 20px 0 0',
          }}
        />
      </div>
    </div>
  );
};

export default PaymentCard;
